<template>
  <div id="pre" class="pre-loader" style="display: flex; justify-content: center;  align-items: center;  align-content: center;">
    <img src="@/assets/images/logo/GF AUTOMOTRIZ-03.png" class="w-100" style="max-width: 260px;"
         alt="Logo de Grupo Felix">
  </div>
</template>

<script>
export default {
  name: 'Preloader'
}
</script>

<style scoped>

</style>
